import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from '@xstyled/styled-components';
import { styleVariables } from '../../../style';
import { jsx as _jsx } from "react/jsx-runtime";
export var StyledTextButton = styled.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n  &:hover,\n  &:focus {\n    color: ", ";\n  }\n"])), function (props) {
  return props.size === 'large' ? '16px' : '14px';
}, styleVariables.colors.gray13, styleVariables.colors.blue3);
export var TextButton = function TextButton(props) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'large' : _props$size,
      children = props.children;
  return /*#__PURE__*/_jsx(StyledTextButton, _objectSpread(_objectSpread({
    size: size
  }, props), {}, {
    children: children
  }));
};